import React from 'react';
import {FieldArray, FastField} from 'formik';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';
import FormGroupCheckbox from '../admin/FormGroupCheckbox';
import SurveyCloudEventsSettingsType from './SurveyCloudEventsSettingsType';

const SurveyCloudEventsSettingsForm = () => (
    <div className="form-group">
        <div className="form-group">
            <FormGroupCheckbox name="cloudEventsEnabled" id="sef_cloudEventsEnabled"
                label={messages.surveys.form.label.cloudEventsEnabled} />
        </div>
        <FastField name="cloudEventsEnabled">
            {({field}) => field.value ? (
                <div className="form-group mt-3">
                    <h4>&gt; <FormattedMessage {...messages.surveys.form.label.cloudEventsSettings.title} /></h4>
                    <FieldArray name="cloudEventsSettings" component={SurveyCloudEventsSettingsType} />
                </div>
            ) : null}
        </FastField>
    </div>
);

export default SurveyCloudEventsSettingsForm;
